<template>
  <div class="subjects-wrapper">
    <div v-for="subject in subjects"
         :key="subject.id"
         class="subject-container">
      <div class="subject-header">
        <div class="subject-info">
          <span class="subject-label">{{ subject.label }}</span>
        </div>
      </div>
      <div class="options-grid">
        <div v-for="option in subject.options"
             :key="option.optionId"
             class="option-item" v-title="option.value">
          <div class="image-wrapper"
               @click="enableZoom ? openModal(option.imageUrl, option.value) : null"
               :class="{ 'zoom-enabled': enableZoom }">
            <img :src="option.imageUrl" :alt="option.value" />
            <div v-if="enableZoom" class="image-overlay">
              <i class="material-icons">search</i>
            </div>
          </div>
          <span class="subject-option-text">{{ option.value }}</span>
        </div>
      </div>
    </div>

    <!-- Modal para imagem expandida -->
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <button class="close-button" @click="closeModal">
          <i class="material-icons">close</i>
        </button>
        <img :src="selectedImage" alt="Imagem expandida" />
        <div class="modal-caption">{{ selectedOptionValue }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubjectsGrid',
  props: {
    subjects: {
      type: Array,
      required: true
    },
    imageSize: {
      type: Number,
      default: 50
    },
    enableZoom: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showModal: false,
      selectedImage: '',
      selectedOptionValue: ''
    }
  },
  methods: {
    openModal (imageUrl, optionValue) {
      this.selectedImage = imageUrl
      this.selectedOptionValue = optionValue
      this.showModal = true
      document.body.style.overflow = 'hidden'
    },
    closeModal () {
      this.showModal = false
      document.body.style.overflow = 'auto'
    }
  }
}
</script>

<style lang="scss" scoped>
.subjects-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;

  .subject-container {
    background: #fff;
    border-radius: 8px;
    padding: 5px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;

    &:hover {
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    }

    .subject-header {
      background: #f8f9fa;
      padding: 5px;
      border-radius: 6px;
      margin-bottom: 5px;

      .subject-info {
        display: flex;
        align-items: center;
        gap: 6px;

        .subject-label {
          font-size: 1.6vh;
          font-weight: 600;
          color: #2c3e50;
          line-height: 1.3;
        }
      }
    }

    .options-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
      gap: 12px;
      padding: 0 4px;

      .option-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #f8f9fa;
        border-radius: 6px;
        padding: 6px;
        transition: all 0.2s ease;

        &:hover {
          transform: translateY(-2px);
          background: #f1f5f9;
        }

        .image-wrapper {
          width: v-bind('`${imageSize}px`');
          height: v-bind('`${imageSize}px`');
          border-radius: 6px;
          overflow: hidden;
          margin-bottom: 4px;
          position: relative;

          &.zoom-enabled {
            cursor: pointer;
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.2s ease;
          }

          .image-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: opacity 0.2s ease;

            i {
              color: white;
              font-size: 2vh;
            }
          }

          &.zoom-enabled:hover {
            .image-overlay {
              opacity: 1;
            }

            img {
              transform: scale(1.1);
            }
          }
        }

        .subject-option-text {
          font-size: 1.4vh;
          color: #4a5568;
          text-align: center;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 1.2;
          cursor: default;
        }
      }
    }
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;

  .modal-content {
    position: relative;
    max-width: 90%;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    img {
      max-width: 60vh;
      max-height: 60vh;
      object-fit: contain;
      border-radius: 8px;
    }

    .modal-caption {
      color: white;
      font-size: 2.5vh;
      text-align: center;
      font-weight: 500;
      max-width: 100%;
      padding: 0 20px;
    }

    .close-button {
      position: absolute;
      top: -30px;
      right: -30px;
      background: rgba(255, 255, 255, 0.1);
      border: none;
      color: white;
      cursor: pointer;
      padding: 5px;
      border-radius: 50%;
      backdrop-filter: blur(4px);
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 2.3vh;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: scale(1.1);
      }
    }
  }
}
</style>
